var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShoppingTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/Shopping Tag/Line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.94282 2.1143C7.44292 1.6142 8.1212 1.33325 8.82844 1.33325L12.6667 1.33325C13.7712 1.33325 14.6667 2.22868 14.6667 3.33325V7.17149C14.6667 7.87874 14.3857 8.55701 13.8856 9.05711L8.74756 14.1952C7.96651 14.9762 6.70018 14.9762 5.91913 14.1952L1.80475 10.0808C1.0237 9.29975 1.0237 8.03342 1.80475 7.25237L6.94282 2.1143ZM8.82844 2.66659C8.47482 2.66659 8.13568 2.80706 7.88563 3.05711L2.74756 8.19518C2.48721 8.45553 2.48721 8.87764 2.74756 9.13799L6.86194 13.2524C7.12229 13.5127 7.5444 13.5127 7.80475 13.2524L12.9428 8.1143C13.1929 7.86425 13.3333 7.52511 13.3333 7.17149V3.33325C13.3333 2.96506 13.0349 2.66659 12.6667 2.66659L8.82844 2.66659Z",
    fill: "#777E91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    d: "M2.39053 6.66669L3.33334 5.72388L10.2762 12.6667L9.33334 13.6095L2.39053 6.66669Z",
    fill: "#777E91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 6.66667C10.3682 6.66667 10.6667 6.36819 10.6667 6C10.6667 5.63181 10.3682 5.33333 10 5.33333C9.63181 5.33333 9.33333 5.63181 9.33333 6C9.33333 6.36819 9.63181 6.66667 10 6.66667ZM10 8C11.1046 8 12 7.10457 12 6C12 4.89543 11.1046 4 10 4C8.89543 4 8 4.89543 8 6C8 7.10457 8.89543 8 10 8Z",
    fill: "#777E91"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingTag);
export default __webpack_public_path__ + "static/media/shopping-tag.5c93bcdf7bdb0965fab5cfb9d020b0d5.svg";
export { ForwardRef as ReactComponent };